import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { GatewayCommissioningStore } from '@store';

import { ViConfirmObject } from '@vi-iot/ui';

@Component({
  selector: 'app-edit-commissioning-step',
  templateUrl: './edit-commissioning-step.component.html',
  styleUrls: ['./edit-commissioning-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditCommissioningStepComponent implements OnInit, OnDestroy {
  viConfirmObject: ViConfirmObject;
  isAnyFormControlFilledOut: boolean;

  @Input() title: string;
  @Input() description: string;
  @Input() showEditButton = false;
  @Input() displayConfirmDialog = false;

  @Output() previousStep = new EventEmitter();

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public gatewayCommissioningStore: GatewayCommissioningStore,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.initViConfirmObject();
    this.gatewayCommissioningStore.isAnyFormControlFilledOut$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isAnyFormControlFilledOut) => {
        this.viConfirmObject.displayDialog = isAnyFormControlFilledOut && this.displayConfirmDialog;
        this.isAnyFormControlFilledOut = isAnyFormControlFilledOut;
      });
  }

  previousStepClicked(): void {
    if (!this.displayConfirmDialog || !this.isAnyFormControlFilledOut) {
      this.confirm();
    }
  }

  confirm(): void {
    this.previousStep.emit();
  }

  private initViConfirmObject(): void {
    this.viConfirmObject = {
      title: this.translateService.instant('+GATEWAY_COMMISSIONING.LOST_FORM_DATA_MODAL.TITLE'),
      content: this.translateService.instant(
        '+GATEWAY_COMMISSIONING.LOST_FORM_DATA_MODAL.DESCRIPTION'
      ),
      cancelBtn: this.translateService.instant('GENERAL.BUTTON.CANCEL'),
      confirmBtn: this.translateService.instant('GENERAL.BUTTON.UNDERSTOOD'),
    };
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
